import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function AddRemarksModal({
  createRichTextEditor,
  addBusinessRemarks,
  showTransaction,
  formData,
  updateList,
  setFormData,
  id,
  updating,
  draftToHtml,
  htmlToDraft,
  convertToRaw,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      remarks: draftToHtml(convertToRaw(formData.remarks.getCurrentContent())),
    };

    addBusinessRemarks(id, args, () => {
      setModal({ isOpen: false });
      showTransaction(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        remarks: htmlToDraft(updateList.remarks),
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createRichTextEditor(
              { key: 'remarks', label: 'Remarks:' },
              {
                minLength: 3,
                required: true,
                maxLength: 500,
                toolbarHidden: true,
              },
              { wrapperClassName: 'border div-css' }
            )}
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AddRemarksModal.propTypes = {
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  // createSelect: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  addBusinessRemarks: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_BUSINESS_TRANSACTION) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddRemarksModal);
